import React from 'react';
import { Seo } from '../shared';
import KnowledgeHubLayout from '../explore/KnowledgeHubLayout';
import DiscoverySection from '../explore/DiscoverySection';
import CategoryGuidesSection from './CategoryGuidesSection';
import { TEMPLES_HUB } from '../../data/touristCultureData';

function TemplesHubPage() {
	const hub = TEMPLES_HUB;

	return (
		<KnowledgeHubLayout
			touristSection="plan"
			touristCurrent="Temples"
			planStepId="temples"
			hideRelated
			seo={(
				<Seo
					title="Temples & Sacred Sites in Nepal"
					path="/temples"
					description="Guide to Nepal's temples and sacred sites — Pashupatinath, Boudhanath, Durbar Squares, Lumbini, etiquette, and Newari architecture."
				/>
			)}
			hero={{
				image: hub.hero,
				eyebrow: 'Discover Nepal',
				title: hub.title,
				lead: hub.lead,
			}}
			quickFacts={hub.quickFacts}
			intro={{
				title: 'Sacred Nepal',
				text: 'Hindu and Buddhist heritage in one small country.',
				body: 'These sites are living places of worship. Dress modestly, move quietly, and follow local customs.',
			}}
			faqs={hub.faqs}
		>
			<DiscoverySection eyebrow="Guide" title="Temples & sacred places">
				{hub.sections.map((s, i) => (
					<div key={s.id} id={s.id} className="info-card arrival-step-card" style={{ marginBottom: '1.25rem' }}>
						<div className="info-card__body">
							<span className="arrival-step-card__num">Section {i + 1}</span>
							<h3 className="info-card__title">{s.question}</h3>
							<p className="info-card__text">{s.answer}</p>
							{s.tips && s.tips.length > 0 && (
								<div className="arrival-tips">
									<p className="arrival-tips__label">Traveler tips</p>
									<ul>{s.tips.map((t) => <li key={t}>{t}</li>)}</ul>
								</div>
							)}
						</div>
					</div>
				))}
			</DiscoverySection>
			<CategoryGuidesSection category="temples" title="Temple & culture guides" alt />
		</KnowledgeHubLayout>
	);
}

export default TemplesHubPage;
